import React, { useCallback, useMemo } from "react";
import { registerCareRecipientInfoAction, } from "../../../../state/usecase/admin/care_recipient/actions";
import { CareRecipientEditComponent, CareRecipientEditComponentProps } from "./CareRecipientEditComponent";
import { CareRecipientName } from "../../../../domain/care_recipient/CareRecipientName";
import { DateObject } from "../../../../domain/fundamental/DateObject";
import { CareRecipientHouseId } from "../../../../domain/care_recipient/CareRecipientHouseId";
import { ServiceProviderId } from "../../../../domain/service_provider/ServiceProviderId";
import { DateTime } from "../../../../domain/fundamental/DateTime";
import { BackButton } from "../../common/button/BackButton";
import { getSensorFromValue, initialCheckedList } from "../../../../domain/care_recipient/Sensor";
import { useAppDispatch } from "../../../../state/store";
import { unwrapResult } from "@reduxjs/toolkit";
import { Paths } from "../../../../Paths";
import { UpdateCareRecipientSuccessResponseType } from "../../../../state/usecase/admin/care_recipient/api";
import { useNavigate } from "react-router-dom";

export function AdminCareRecipientAddPage() {
    const dispatch = useAppDispatch();

    const navigate = useNavigate();

    const whenUpdateClicked = useCallback((
        name: CareRecipientName,
        birthday: DateObject,
        houseId: CareRecipientHouseId,
        serviceProviderId: ServiceProviderId,
        dataSyncStartTime: DateTime | null,
        dataSyncEndTime: DateTime | null,
        sensors: string[],
        customerCode: string,
        branchCode: string,
    ) => {
        dispatch(
            registerCareRecipientInfoAction({
                requestData: {
                    name: name,
                    birthday: birthday,
                    houseId: houseId,
                    serviceProviderId: serviceProviderId,
                    dataSyncStartTime: dataSyncStartTime,
                    dataSyncEndTime: dataSyncEndTime,
                    sensors: sensors.map(sensor => getSensorFromValue(sensor)),
                    classification: null,
                    alertPeriod: null,
                    alertPause: null,
                    customerCode: customerCode,
                    branchCode: branchCode,
                },
                onFailure: () => alert("ハウスIDが登録済みです")
            })
        )
            .then(unwrapResult)
            .then((res: { careRecipientInfo: UpdateCareRecipientSuccessResponseType }) => {
                navigate(`${Paths.admin}${Paths.careRecipient}${Paths.edit}/${res.careRecipientInfo.id}`, { replace: true });
            });
    }, [dispatch, history]);

    const props: CareRecipientEditComponentProps = useMemo(() => ({
        type: "登録",
        name: null,
        houseId: null,
        branchCode: null,
        customerCode: null,
        birthday: DateObject.default(),
        serviceProviderId: null,
        dataSyncStartTime: null,
        dataSyncEndTime: null,
        sensors: initialCheckedList,
        classification: null,
        classificationSelectList: [],
        diseases: null,
        alertPeriod: null,
        alertPause: null,
        whenUpdateClicked: whenUpdateClicked
    }), [whenUpdateClicked]);

    return (
        <div className={"admin_care_recipient_add_page"}>
            <BackButton/>
            <div className={"header"}>
                利用者登録
            </div>
            <CareRecipientEditComponent {...props} />
        </div>
    );
}
